import React from 'react';
import cn from 'classnames';

import { ISubmissionButtonsProps } from './SubmissionButtons.types';

import Button from '../Button';
import Tooltip from '../Tooltip';
import { EButtonType } from './enum';

import './SubmissionButtons.scss';

const SubmissionButtons: React.FC<ISubmissionButtonsProps> = ({
	className,
	disabledNegative,
	disabledProceed,
	disabledPositive,
	isLoading,
	isNegativeButtonNeeded = true,
	isPositiveButtonNeeded = true,
	isProceedButtonNeeded = false,
	isWithoutBtnRightPadding = false,
	negativeLabel = 'Cancel',
	positiveLabel = 'Submit',
	proceedLabel = 'Proceed',
	type = EButtonType.submit,
	tooltipPositiveButton,
	tooltipNegativeButton,
	tooltipProceedButton,
	position = 'right',
	negativeHandler,
	proceedHandler,
	positiveHandler,
}) => {
	const classNames = cn('f5gSubmissionButtonsContainer', className, position, {
		'f5gSubmissionButtonsContainerWithoutRightPadding': isWithoutBtnRightPadding,
	});
	return (
		<div className={classNames}>
			{isNegativeButtonNeeded && (
				<Tooltip
					content={tooltipNegativeButton}
					isDisabled={!tooltipNegativeButton}
				>
					<div>
						<Button
							className='no-wrap'
							disabled={disabledNegative || isLoading}
							large
							onClick={negativeHandler}
							text={negativeLabel}
							withoutBackground
						/>
					</div>
				</Tooltip>
			)}
			{isProceedButtonNeeded && (
				<Tooltip
					content={tooltipProceedButton}
					isDisabled={!tooltipProceedButton}
				>
					<Button
						disabled={disabledProceed}
						large
						onClick={proceedHandler}
						secondary
						text={proceedLabel}
					/>
				</Tooltip>
			)}
			{isPositiveButtonNeeded && (
				<Tooltip
					content={tooltipPositiveButton}
					isDisabled={!tooltipPositiveButton}
				>
					<div>
						<Button
							disabled={disabledPositive || isLoading}
							large
							onClick={positiveHandler}
							text={positiveLabel}
							type={type}
						/>
					</div>
				</Tooltip>
			)}
		</div>
	);
};

export default SubmissionButtons;
